exports = module.exports = require("../../../../shared/frontend/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/*#app {*/\n/*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/\n/*-webkit-font-smoothing: antialiased;*/\n/*-moz-osx-font-smoothing: grayscale;*/\n/*text-align: center;*/\n/*color: #2c3e50;*/\n/*margin-top: 60px;*/\n/*}*/\n.toast {\n  background-color: transparent;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/css-loader?{"minimize":false,"sourceMap":false}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/style-compiler?{"id":"data-v-25441132","scoped":false,"hasInlineConfig":true}!/home/alarmplan/staging/shared/frontend/~/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 782
// module chunks = 1